// extracted by mini-css-extract-plugin
export default {"component":"FormBlock_component__mFw0l","title":"FormBlock_title__y5Tzx","spin":"FormBlock_spin__87D8f"};